<template>
  <main class="sales-admin-page">
    <Tabs :tabs="tabs" aria-label="Sales admin sections">
      <template #orders>
        <section class="sales-admin-page__section">
          <OrdersTab />
        </section>
      </template>

      <template #convoys>
        <section class="sales-admin-page__section">
          <h2>Convoys</h2>
          <p>Coming soon...</p>
        </section>
      </template>

      <template #order-export>
        <section class="sales-admin-page__section">
          <h2>Order export</h2>
          <p>Coming soon...</p>
        </section>
      </template>

      <template #customer-groups>
        <section class="sales-admin-page__section">
          <h2>Customer groups</h2>
          <p>Run the customer club level updater in its dedicated admin view.</p>
          <a class="button button--small" href="/sales-admin/customer-groups">
            Open customer groups
          </a>
        </section>
      </template>
    </Tabs>
  </main>
</template>

<script setup lang="ts">
import Tabs from "@shared/Components/Tabs/Tabs.vue";
import OrdersTab from "@features/Pages/SalesAdminPage/Components/OrdersTab/OrdersTab.vue";

const tabs: TabsItem[] = [
  {
    id: "orders",
    label: "Orders",
  },
  {
    id: "convoys",
    label: "Convoys",
  },
  {
    id: "order-export",
    label: "Order export",
  },
  {
    id: "customer-groups",
    label: "Customer groups",
  },
];
</script>
